/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

export const calculateNewSelection = (
  currentSelectedIndices: number[],
  clickedIndex: number,
  isShiftClick: boolean,
): number[] => {
  if (isShiftClick) {
    if (currentSelectedIndices.includes(clickedIndex)) {
      return currentSelectedIndices.filter((i) => i !== clickedIndex);
    }
    return [...currentSelectedIndices, clickedIndex];
  }

  const isSoleSelection =
    currentSelectedIndices.length === 1 &&
    currentSelectedIndices[0] === clickedIndex;

  return isSoleSelection ? [] : [clickedIndex];
};

export const getAffectedIndices = (
  oldSelection: number[],
  newSelection: number[],
): number[] => {
  const allIndices = new Set([...oldSelection, ...newSelection]);
  return Array.from(allIndices).filter(
    (idx) => oldSelection.includes(idx) !== newSelection.includes(idx),
  );
};

export const shouldEnterEditMode = (
  isReadonly: boolean,
  isShiftClick: boolean,
  newSelectionCount: number,
): boolean => !isReadonly && !isShiftClick && newSelectionCount === 1;

export const shouldExitEditModeForMultiSelect = (
  newSelectionCount: number,
): boolean => newSelectionCount > 1;

export const calculateBoxSelection = (
  currentSelectedIndices: number[],
  boxSelectedIndices: number[],
  addToSelection: boolean,
): number[] =>
  addToSelection
    ? Array.from(new Set([...currentSelectedIndices, ...boxSelectedIndices]))
    : boxSelectedIndices;
